<app-top-bar-navigation [showBackButton]="true" title="About Sleep Research" (backBtnClicked)="back()"/>
<div siqGrid class="px-24 py-32">
  <app-learn-more class="w-100-p"/>
</div>
